<template>
  <global-dialog-card
    v-model="model"
    :title="payout ? $t('finance_payout_title', { period: payout.period }) : $t('finance_payout_fallback_title')"
    hide-actions
    max-width="440"
  >
    <div v-if="payout" class="breakdown-list">
      <div class="breakdown-row">
        <span>{{ $t("finance_total_turnover") }}</span>
        <strong>{{ formatCurrency(payout.breakdown.turnover) }}</strong>
      </div>
      <div class="breakdown-row deduction">
        <span>{{ $t("finance_commission") }}</span>
        <strong>-{{ formatCurrency(payout.breakdown.commission) }}</strong>
      </div>
      <div class="breakdown-row deduction">
        <span>{{ $t("finance_marketing") }}</span>
        <strong>-{{ formatCurrency(payout.breakdown.marketing) }}</strong>
      </div>
      <div class="breakdown-row deduction">
        <span>{{ $t("finance_refunds_label") }}</span>
        <strong>-{{ formatCurrency(payout.breakdown.refunds) }}</strong>
      </div>
      <div class="breakdown-row deduction">
        <span>{{ $t("finance_delivery") }}</span>
        <strong>-{{ formatCurrency(payout.breakdown.delivery) }}</strong>
      </div>
      <div class="breakdown-row deduction">
        <span>{{ $t("finance_vat") }}</span>
        <strong>-{{ formatCurrency(payout.breakdown.vat) }}</strong>
      </div>

      <v-divider class="my-2" />

      <div class="breakdown-row total">
        <span>{{ $t("finance_paid_out") }}</span>
        <strong class="success--text">{{ formatCurrency(payout.breakdown.paidOut) }}</strong>
      </div>

      <p class="section-label mt-4">{{ $t("finance_actions_label") }}</p>
      <div class="actions-row">
        <print-button @click="mockAction('PDF')" />
        <excel-button @click="mockAction('Excel')" />
        <v-btn small outlined @click="mockAction($t('finance_resend_email'))">
          <v-icon small class="mr-1">mdi-email-sync-outline</v-icon>
          {{ $t("finance_resend_email") }}
        </v-btn>
      </div>
    </div>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import GlobalDialogCard from "@/components/global/GlobalDialogCard.vue";

export default {
  name: "PayoutDetailDialog",

  components: { GlobalDialogCard },

  mixins: [hasModel, hasSnackbar],

  props: {
    payout: {
      type: Object,
      default: null,
    },
  },

  methods: {
    formatCurrency(amount) {
      const value = Number(amount) || 0;
      return `${value.toFixed(2)} ${this.restaurantCurrency}`;
    },

    mockAction(action) {
      this.showInfoSnackbar(this.$t("finance_action_not_connected", { action }));
    },
  },
};
</script>

<style scoped>
.breakdown-list {
  display: grid;
  gap: 8px;
}

.breakdown-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.88rem;
}

.breakdown-row.deduction {
  color: rgba(0, 0, 0, 0.6);
}

.breakdown-row.total {
  font-size: 1.05rem;
}

.section-label {
  margin: 0 0 8px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(0, 0, 0, 0.5);
}

.actions-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
